












































































































import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import {
  Company,
  CompanyCollection,
  Order,
  PriceList,
  PriceListCollection,
  PriceListEntry,
  MasterCatalog,
  MasterCatalogCollection,
  ReminderCollection,
  Reminder,
  IVendorPriceListEntry
} from 'serverless-firestore'
import LabeledValue from '@/components/LabeledValue.vue'
import store, { Actions } from '../../../store'
import EnableVendorModal from '@/components/Onboarding/EnableVendorModal.vue'
import SaveButton from '@/components/SaveButton.vue'
import ProductSelector from '@/components/Order/ProductSelector.vue'

@Component({
  components: {
    LabeledValue,
    SaveButton,
    LoadingPage,
    EnableVendorModal,
    ProductSelector
  }
})
export default class VendorDetails extends Mixins(IconsMixin, AuthMixin) {
  public vendor: Company | null = null
  public masterCatalog: MasterCatalog = {} as MasterCatalog;
  public orders: Order[] = [];
  public priceLists: PriceList[] = [];
  public reminders: Reminder[] =[];
  public errors: string[] = []
  public isSaving: boolean = false
  public priceListEntries: IVendorPriceListEntry[] = []
  public reminderEntries: { [priceListEntryId: string]: IVendorPriceListEntry } = {
    [""]: {
      description: "",
      id: "",
      priceListId: "",
      upc: "",
      vendorCompanyId: ""
    }
  }
  public selectedReminder: Reminder = {} as Reminder
  public isLoading: boolean = false

  public showDeleteModal = false

  public $refs!: {
    form: HTMLFormElement
  }

  public async mounted() {
    try {
      this.isLoading = true

      const firestore = ( await this.$firebase ).firestore()
      const vendorId = this.$route.params.id

      const companyCollection = new CompanyCollection(firestore)
      const vendor = await companyCollection.getCompany(vendorId)
      if (vendor) {
        this.vendor = vendor
      } else {
        const err = new Error('You do not have permissions to view that page')
        return store.dispatch(Actions.SET_ERROR, [err, this.$router])
      }

      const reminderCollection = new ReminderCollection(firestore)

      await this.populatePriceListEntries()

      this.reminders = await reminderCollection.listRemindersByRestaurantCompanyIdAndVendorCompanyId(this.userCompany.id, vendorId)
      this.reminders.forEach(reminder => {
        this.reminderEntries[reminder.priceListEntryId] = this.getPriceListEntry(reminder)
      })

      if (!this.reminders.length) {
        this.addReminder()
      }

      this.isLoading = false
    } catch (error) {
      const err = new Error('You do not have permissions to view that page')
      return store.dispatch(Actions.SET_ERROR, [error, this.$router])
    }
  }

  public areRemindersValid(reminders: Reminder[] | null): reminders is Reminder[] {
    if(!reminders) {
      return false
    }

    if(!this.$refs.form.validate()) {
      if(
        !reminders.every(reminder => reminder.priceListEntryId && reminder.priceListEntryId.length)
      ) {
        this.errors.push("You must select an item for every reminder")
      }
      if(!reminders.every(reminder => reminder.text && reminder.text.length)) {
        this.errors.push("You must enter text for every reminder")
      }
    }

    return !!this.$refs.form.validate()
      && reminders.every(reminder => reminder instanceof Reminder)
      && !!reminders
      && !!reminders.length
      && !this.errors.length
  }

  public async updateReminders() {
    if (this.areRemindersValid(this.reminders)) {
      const reminderCollection = new ReminderCollection(( await this.$firebase ).firestore())
      this.reminders.map(async reminder => {
        await reminderCollection.save(reminder)
      })
    }
  }

  public async save() {
    this.errors = []
    this.removeEmptyEntries()
    await this.$nextTick()

    if (!this.areRemindersValid(this.reminders)) {
      return
    }

    this.isSaving = true

    await this.updateReminders()
    if (this.vendor) {
      await this.$router.push({ name: 'vendor-details', params: { id: this.vendor.id } })
    } else {
      const err = new Error('No Vendor Found')
      return store.dispatch(Actions.SET_ERROR, [err, this.$router])
    }

    this.isSaving = false
  }

  public async deleteReminder(reminder: Reminder) {
    if (!this.reminders || !reminder) {
      return
    } else if (
      !reminder.vendorCompanyId
      || !reminder.restaurantCompanyId
      || !reminder.priceListEntryId
      || !reminder.id
    ) {
      return this.removeReminder(reminder)
    }

    const reminderCollection = new ReminderCollection(( await this.$firebase ).firestore())
    await reminderCollection.delete(reminder)
    this.removeReminder(reminder)
  }

  public getPriceListEntry(reminder: Reminder): IVendorPriceListEntry {
    if (!reminder || !reminder.priceListEntryId) {
      return { id: '', upc: '', description: 'N/A', priceListId: '', vendorCompanyId: '' } as IVendorPriceListEntry
    }

    const priceListEntry = this.priceListEntries.find(entry => entry.id === reminder.priceListEntryId)
    if (!priceListEntry) {
      return { id: reminder.priceListEntryId, upc: '', description: 'N/A', priceListId: '', vendorCompanyId: '' } as IVendorPriceListEntry
    }

    return priceListEntry
  }

  public updateDetails(reminder: Reminder, priceListEntry: IVendorPriceListEntry) {
    reminder.priceListEntryId = priceListEntry.id
    const entry = this.getPriceListEntry(reminder)
    this.reminderEntries[reminder.priceListEntryId] = entry
  }

  public addReminder() {
    if (!this.vendor) {
      return
    }

    const reminder = new Reminder('', this.vendor.id, this.userCompany.id, '')
    this.reminderEntries[reminder.priceListEntryId] = this.getPriceListEntry(reminder)
    this.reminders.unshift(reminder)
  }

  public confirmDelete(reminder: Reminder) {
    this.showDeleteModal = false
    this.deleteReminder(reminder)
  }

  public removeReminder(reminder: Reminder) {
    if (!this.reminders) {
      return
    }

    const index = this.reminders.indexOf(reminder)
    if (index !== -1) {
      this.reminders.splice(index, 1)
    }
  }

  private removeEmptyEntries() {
    // filter out any blank reminder entries
    if(this.reminders && this.reminders.length) {
      this.reminders = this.reminders.filter(reminder => reminder.text || reminder.priceListEntryId)
    }
  }

  private async populatePriceListEntries() {
    if (!this.vendor) {
      const err = new Error('You do not have permissions to view that page')
      return store.dispatch(Actions.SET_ERROR, [err, this.$router])
    }

    const priceListCollection = new PriceListCollection(( await this.$firebase ).firestore())
    this.priceLists = await priceListCollection.listPriceListsByRestaurantAndVendor(this.userCompany.id, this.vendor.id)

    const masterCatalogCollection = new MasterCatalogCollection(( await this.$firebase ).firestore())

    this.priceLists.forEach(async (priceList: PriceList) => {
      priceList.entries.forEach((entry: PriceListEntry) => {
        this.priceListEntries.push({ ...entry, priceListId: priceList.id, vendorCompanyId: priceList.vendorCompanyId })
      })
      const masterCatalog = await masterCatalogCollection.getByCompanyId(priceList.vendorCompanyId)
      if(masterCatalog && masterCatalog.entries && masterCatalog.entries.length) {
        masterCatalog.entries.forEach((entry: PriceListEntry) => {
          this.priceListEntries.push({ ...entry, priceListId: priceList.id, vendorCompanyId: masterCatalog.companyId })
        })
      }
    })
  }
}
